__turbopack_context__.v({
  "actionCol": "standingTable-module-scss-module__hcNWFW__actionCol",
  "alignCenter": "standingTable-module-scss-module__hcNWFW__alignCenter",
  "amountCell": "standingTable-module-scss-module__hcNWFW__amountCell",
  "cell": "standingTable-module-scss-module__hcNWFW__cell",
  "container": "standingTable-module-scss-module__hcNWFW__container",
  "countCell": "standingTable-module-scss-module__hcNWFW__countCell",
  "dataTable": "standingTable-module-scss-module__hcNWFW__dataTable",
  "emptyCell": "standingTable-module-scss-module__hcNWFW__emptyCell",
  "leftInnerShadow": "standingTable-module-scss-module__hcNWFW__leftInnerShadow",
  "legendHeaderColumn": "standingTable-module-scss-module__hcNWFW__legendHeaderColumn",
  "legendHeaderStyle": "standingTable-module-scss-module__hcNWFW__legendHeaderStyle",
  "rankCell": "standingTable-module-scss-module__hcNWFW__rankCell",
  "rankLegendHeaderColumn": "standingTable-module-scss-module__hcNWFW__rankLegendHeaderColumn",
  "selectedCell": "standingTable-module-scss-module__hcNWFW__selectedCell",
  "withoutAmount": "standingTable-module-scss-module__hcNWFW__withoutAmount",
  "wrapperCell": "standingTable-module-scss-module__hcNWFW__wrapperCell",
  "wrapperHeaderCell": "standingTable-module-scss-module__hcNWFW__wrapperHeaderCell",
  "wrapperRankHeaderCell": "standingTable-module-scss-module__hcNWFW__wrapperRankHeaderCell",
  "yearHeaderArrowCell": "standingTable-module-scss-module__hcNWFW__yearHeaderArrowCell",
  "yearHeaderColumn": "standingTable-module-scss-module__hcNWFW__yearHeaderColumn",
});
